import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import logoImage from '../images/digital.png';

function Footer() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleSectionClick = (id) => (event) => {
        if (location.pathname === "/") {
            event.preventDefault();
            navigate(`/#${id}`);
            const section = document.getElementById(id);
            if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <footer className="ciits-footer">
            <div className="ciits-container">
                <div className="footer-grid">
                    <div>
                        <div className="footer-brand">
                            <img src={logoImage} alt="CIITS logo" />
                            <div>
                                <strong>CIITS</strong>
                                <span style={{ color: "rgba(255,255,255,0.48)", fontSize: "0.7rem" }}>Central India IT Services</span>
                            </div>
                        </div>
                        <p className="footer-tagline">Empowering Your Digital Future</p>

                        <div className="footer-socials" aria-label="CIITS social media">
                            <a className="footer-social" href="https://www.facebook.com/ciits24" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
                            <a className="footer-social" href="https://x.com/contactciits?t=q3tB7vKEypefWYoDydo2KA&s=08" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
                            <a className="footer-social" href="https://www.linkedin.com/company/central-india-it-services/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
                            <a className="footer-social" href="https://www.instagram.com/ciits24?igsh=eDFlYXd0czFvZTc4" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h3>Contact Us</h3>
                        <p style={{ margin: "0 0 7px" }}>
                            <a href="mailto:contact@ciits.in">contact@ciits.in</a>
                        </p>
                        <p style={{ margin: 0 }}>
                            <a href="tel:+918770746285">Phone: +91 8770746285</a>
                        </p>
                    </div>

                    <div className="footer-column">
                        <h3>Our Address</h3>
                        <p style={{ margin: 0 }}>
                            CIITS Office,<br />
                            Rewa, Madhya Pradesh,<br />
                            India - 486001
                        </p>
                    </div>

                    <div className="footer-column">
                        <h3>Quick Links</h3>
                        <ul className="footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/#services" onClick={handleSectionClick("services")}>Services</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <span>&copy; {new Date().getFullYear()} CIITS. All rights reserved.</span>
                    <span>Central India IT Services</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
